import { render } from "./InactiveFreezers.vue?vue&type=template&id=409b1fde"
import script from "./InactiveFreezers.vue?vue&type=script&lang=js"
export * from "./InactiveFreezers.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\c.turnbull.VT\\Documents\\GitHub\\vars-portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__